import React, { useState, useCallback, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { AddImageIcon, CrownIcon, DownloadIcon } from '../../../assets/icons/iconshere';
import { CancelIcon } from '../../../SvgIconsData';
import CertificateTemplate from '../../CertificateTemplate';
import ProPopup from '../../layouts/ProPopup';

const CertificatePage = ({certificateConfig, getGroupCertificateDetails}) => {
  const configData = useSelector(state => state.configSlice);
  let MODE = configData.config.MODE;
  const userData = useSelector(state => state.userSlice);
  const [openPro, setOpenPro] = useState(false);
  const [userPlan, setUserPlan] = useState(null);

  const [updating, setUpdating] = useState(false);
  const [signingAuthority , setSigningAuthority] = useState({
    name : "",
    designation : "",
    signature : ""
  });
  
  const [organizationDetails , setOrganizationDetails] = useState({
    name : "",
    logo : ""
  });

  useEffect(() => {
    userData?.plans?.data && setUserPlan(userData.plans.data);
  }, [userData]);

  useEffect(()=>{
      setSigningAuthority({
          name : certificateConfig?.signatory || "",
          designation : certificateConfig?.designation || "",
          signature : certificateConfig?.signature || ""
      });
      setOrganizationDetails({
          name : certificateConfig?.orgName || "",
          logo : certificateConfig?.orgLogo || ""
      });
    
  },[certificateConfig])
  
  const onDropOrgLogo = useCallback(async(acceptedFiles) => {
    const file = acceptedFiles[0];
    // const imageUrl = URL.createObjectURL(file);
    const formData = new FormData();
    formData.append('file', file);

    const { data } = await axios.post(`${configData.config.UNO_URL}/api/user/group/upload/organization`, formData, {
      headers: {
          Authorization: `Bearer ${userData?.token}`,
          "Content-Type ": "multipart/form-data"
      }
    });

    setOrganizationDetails((pre)=>({
      ...pre,
      logo:data.url
    }));

  }, []);

  const onDropSignLogo = useCallback(async(acceptedFiles) => {
    const file = acceptedFiles[0];
    // const imageUrl = URL.createObjectURL(file);
    const formData = new FormData();
    formData.append('file', file);
    
    const { data } = await axios.post(`${configData.config.UNO_URL}/api/user/group/upload/signature`, formData, {
      headers: {
        Authorization: `Bearer ${userData?.token}`,
        "Content-Type ": "multipart/form-data"
      }
    });
    
    setSigningAuthority((pre)=>({
      ...pre,
      signature:data.url
    }));

  }, []);

  const { getRootProps:getRootProps1, getInputProps:getInputProps1 } = useDropzone({
    onDrop : onDropSignLogo,
    accept: 'image/*',
    multiple: false,
  });

  const { getRootProps:getRootProps2, getInputProps:getInputProps2 } = useDropzone({
    onDrop : onDropOrgLogo,
    accept: 'image/*',
    multiple: false,
  });

  const handleCancelUpload = (event, name) => {
    event.stopPropagation();
   if(name == "signature"){
      setSigningAuthority((pre)=>({
        ...pre,
        signature: null
      }));
   }else if(name == "organization"){
    setOrganizationDetails((pre)=>({
      ...pre,
      logo: null
    }));
   }
  };

  const handleSigningInputChange = (e)=> {
    const { name, value } = e.target;
    setSigningAuthority((prev) => ({ ...prev, [name]: value }));
  }

  const handleOrgInputChange = (e)=> {
    const { name, value } = e.target;
    setOrganizationDetails((prev) => ({ ...prev, [name]: value }));
  }

  const handleUpdateCertificate = async() =>{
    try {
      
      setUpdating(true);
      let _bodyData={
          "orgLogo": organizationDetails.logo, 
          "orgName": organizationDetails.name, 
          "signatory": signingAuthority.name, 
          "signature": signingAuthority.signature, 
          "designation": signingAuthority.designation
      }

      await axios.post(`${configData.config.UNO_URL}/api/user/group/update/certificate/${MODE}`, _bodyData, {
        headers: {
            Authorization: `Bearer ${userData.token}`,
            "Content-Type ": "application/json"
        }});

    } catch (error) {
      console.log(error);
    } finally{
      setUpdating(false);
      getGroupCertificateDetails();
    }
  }

  const resetToDefault = async() =>{
    try {
      if(window.confirm("Are you sure to reset")){
        await axios.post(`${configData.config.UNO_URL}/api/user/group/remove/certificate/${MODE}`, {}, {
          headers: {
              Authorization: `Bearer ${userData.token}`,
              "Content-Type ": "application/json"
          }});
      }
    } catch (error) {
      console.log(error);
    } finally{
      setUpdating(false);
      getGroupCertificateDetails();
    }
  }

  return (
    <>
          <div className='cert-section'>
              
                <div className='edit-field'>
                  <div className='input-head'>
                    <h6>Signing Authorities</h6>
                    <div className='row'>
                      <div className="col-md-12">

                        <div className="quesformbox mt-2">
                          <p>Name</p>
                          <div className='input-load'>
                            <input
                              name="name"
                              placeholder="Name"
                              type="text"
                              className="input mt-2"
                              value={signingAuthority.name}
                              onChange={handleSigningInputChange}
                            ></input>
                            <div className="spinner"></div>
                          </div>
                        </div>

                        <div className="quesformbox mt-3">
                          <p>Designation</p>
                          <input
                            name="designation"
                            placeholder="Designation"
                            type="text"
                            className="input mt-2"
                            value={signingAuthority.designation}
                            onChange={handleSigningInputChange}
                          ></input>
                        </div>

                        <div className='image-formbox mt-3'>
                        
                          <div {...getRootProps1()} className="dropbox mt-2">
                            <input {...getInputProps1()} name='signature' onChange={handleSigningInputChange}   />
                           
                            {signingAuthority.signature ? (
                              <div className="uploaded-container">
                                <img src={signingAuthority.signature} alt="Uploaded" className="uploaded-image" />
                                <button onClick={(e)=>handleCancelUpload(e, "signature")} className="cancel-button">
                                  <CancelIcon/>
                                </button>
                              </div>
                            ) : (
                              <div className="placeholder">
                                <AddImageIcon/>
                              </div>
                            )}

                        </div>
                        <div className='d-flex align-items-start flex-column justify-content-start'>
                        <p>Signature</p>
                        <p className='little-info'>Recommended Format* PNG</p>
                        </div>
                        </div>
                        

                      </div>
                    </div>
                  </div>
                  <div className='input-head mt-4'>
                    <h6>Organization Details</h6>
                    <div className='row'>
                      <div className="col-md-12">
                        <div className="quesformbox mt-1">
                          <p>Organization Name</p>
                          <div className='input-load'>
                            <input
                              name="name"
                              placeholder="Name"
                              type="text"
                              className="input mt-2"
                              value={organizationDetails.name}
                              onChange={handleOrgInputChange}
                            ></input>
                            <div className="spinner"></div>
                          </div>
                        </div>
                  
                        <div className='image-formbox mt-3'>
                        
                          <div {...getRootProps2()} className="dropbox mt-2">
                          <input {...getInputProps2()} name='logo' onChange={handleOrgInputChange} />
                          
                          {organizationDetails.logo ? (
                            <div className="uploaded-container">
                              <img src={organizationDetails.logo} alt="Uploaded" className="uploaded-image" />
                              <button onClick={(e)=>handleCancelUpload(e,"organization")} className="cancel-button">
                              <CancelIcon/>
                              </button>
                            </div>
                          ) : (
                            <div className="placeholder">
                              <AddImageIcon/>
                            </div>
                          )}

                        </div>
                        <div className='d-flex align-items-start flex-column justify-content-start'>
                        <p>Organization Logo</p>
                        <p className='little-info'>Recommended Format* PNG</p>
                        </div>
                        </div>
                        

                      </div>
                    </div>
                  </div>
                </div>

                <div className='preview-field' style={{maxWidth:"1000px"}}>
                  <div className=' launch-down pb-2 d-flex align-items-center justify-content-between'>

                  <h6>Certificate preview</h6>
                  
                  {/* <span> <DownloadIcon/> Template </span>         */}
                  </div>

                  <div className='html-parent-parent'>
                  <div className='html-parent'>
                    <CertificateTemplate 
                    organizationDetails={organizationDetails} 
                    signingAuthority={signingAuthority}  
                    />
                  </div>
                  </div>
                  <div className="footerbtn text-end mt-1 pe-2">
                    {userData.user.group.parentId && <button className="cancel" onClick={resetToDefault}> set default </button>}

                    <button className="cancel" onClick={()=>getGroupCertificateDetails()}>Cancel</button>
                  
                  {updating ?
                    <button className="loading save">
                        <svg viewBox="25 25 50 50">
                          <circle r="20" cy="50" cx="50"></circle>
                        </svg>
                      </button>
                    :

                  (userPlan?.certificateConfig?.access) ?
                    <button className="save" onClick={handleUpdateCertificate}> Update</button>
                    :
                    <button className="save" onClick={() => {setOpenPro(true)}}> <span className='pe-0'><CrownIcon  /></span>  Update   </button>
                  }
                  </div>
                </div>
          </div>

          <ProPopup openPro={openPro} setOpenPro={setOpenPro} />          
    </>
  );
};

export default CertificatePage;
